import React, { useRef, useState } from "react";
import {
  ContentCarouselBase,
  Header,
  Card,
  CardImage,
  Slide,
  SliderNav,
  SliderArrow,
  CardTitle,
} from "./content-carousel.styled";
import {
  ContentCarouselSliceFragment,
  PrismicReusableContent,
  PrismicReusableContentDataBodyImageGrid,
  PrismicReusableContentDataBodyRichTextV2,
} from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { htmlSerializer } from "../../utils/htmlSerializer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import theme from "../../styles/theme";
import { SliderClass } from "./content-carousel.styled";
import * as FA from "../../styles/fontawesome";
import { buildUrl } from "../../utils/environment-urls";
import { useThemeContext } from "../../utils/theme-context";

export type IContentCarouselProps = Slice<
  SharedSliceType,
  ContentCarouselSliceFragment["primary"]
> & { type: SharedSliceType.content_carousel };

const getLinkedContentItems = (linkedContent: PrismicReusableContent) => {
  console.log("[ContentCarousel] linkedContent", linkedContent);
  let itemDocumentImageGrid =
    undefined as unknown as PrismicReusableContentDataBodyImageGrid;

  let itemDocumentRichTextV2 =
    undefined as unknown as PrismicReusableContentDataBodyRichTextV2[];

  if (linkedContent?.data?.body?.length > 0) {
    itemDocumentImageGrid = linkedContent.data.body.filter(
      (body) => body.slice_type === SharedSliceType.image_grid
    )[0] as PrismicReusableContentDataBodyImageGrid;

    itemDocumentRichTextV2 = linkedContent.data.body.filter(
      (body) => body.slice_type === "rich_text_v2"
    ) as PrismicReusableContentDataBodyRichTextV2[];
  }

  return {
    itemDocumentImageGrid,
    itemDocumentRichTextV2,
  };
};

const ContentCarousel = ({
  slice,
}: SliceComponentProps<IContentCarouselProps, IPageContext>) => {
  console.log("[ContentCarousel] slice", slice);
  const { primary } = slice;
  const sliderRef = useRef<Slider>(null);
  const [sliderInitialized, setSliderInitialized] = useState(false);

  const { itemDocumentImageGrid, itemDocumentRichTextV2 } =
    getLinkedContentItems(primary?.content?.document as PrismicReusableContent);
  console.log("[ContentCarousel] itemDocumentImageGrid", itemDocumentImageGrid);
  console.log(
    "[ContentCarousel] itemDocumentRichTextV2",
    itemDocumentRichTextV2
  );
  const { currentMode, currentTransitionPercent } = useThemeContext();

  return (
    <ContentCarouselBase>
      <div className="container">
        <Header
          isDarkMode={currentMode}
          transitionPercent={currentTransitionPercent}
        >
          <PrismicRichText
            field={primary.primary_heading.richText}
            components={htmlSerializer}
          />
          <PrismicRichText
            field={primary.primary_description.richText}
            components={htmlSerializer}
          />
        </Header>

        <Slider
          className={SliderClass}
          dots={false}
          fade={false}
          speed={500}
          slidesToScroll={1}
          infinite={true}
          arrows={false}
          ref={sliderRef}
          centerMode={false}
          autoplay={false}
          variableWidth={true}
          initialSlide={0}
          onInit={() => setSliderInitialized(true)}
          autoplaySpeed={2500}
          slidesToShow={5}
          responsive={[
            {
              breakpoint: theme.breakpoints[4],
              settings: {
                slidesToShow: 4,
                autoplay: false,
                centerMode: false,
                infinite: false,
                variableWidth: false,
              },
            },
            {
              breakpoint: theme.breakpoints[1],
              settings: {
                slidesToShow: 2,
                autoplay: false,
                centerMode: false,
                infinite: false,
                variableWidth: false,
              },
            },
          ]}
        >
          {sliderInitialized &&
            itemDocumentImageGrid?.items?.map((item) => {
              return (
                <Slide>
                  {item.image && item.primary_cta_link?.url && (
                    <Card href={buildUrl(item.primary_cta_link?.url)}>
                      <CardImage
                        image={item.image?.gatsbyImageData}
                        alt={item.image?.alt || "Xometry Resources"}
                        loading="lazy"
                      />
                      <CardTitle>{item.title}</CardTitle>
                    </Card>
                  )}
                </Slide>
              );
            })}
          {sliderInitialized &&
            itemDocumentRichTextV2?.map((item) => {
              console.log("item", item);
              return (
                <Slide>
                  {item && item?.primary && (
                    <div>
                      <PrismicRichText
                        field={item.primary.heading.richText}
                        components={htmlSerializer}
                      />
                      <PrismicRichText
                        field={item.primary.description.richText}
                        components={htmlSerializer}
                      />
                    </div>
                  )}
                </Slide>
              );
            })}
        </Slider>

        <SliderNav>
          <SliderArrow onClick={() => sliderRef.current?.slickPrev()}>
            <i css={FA.AngleLeftRegular} />
          </SliderArrow>
          <SliderArrow onClick={() => sliderRef.current?.slickNext()}>
            <i css={FA.AngleRightRegular} />
          </SliderArrow>
        </SliderNav>
      </div>
    </ContentCarouselBase>
  );
};

export default ContentCarousel;
